import React from 'react';

import type { SkeletonProps } from '../types';
import { CardListSkeleton } from '../components/CardListSkeleton';

export const createCardListSkeleton =
	(
		props: React.ComponentPropsWithoutRef<typeof CardListSkeleton>,
	): React.ComponentType<SkeletonProps> =>
	({ testId }: SkeletonProps): React.JSX.Element => <CardListSkeleton {...props} testId={testId} />;
